import type { Column, Filter } from '@/components/table/base'

import { StandarizedGolfPlayer } from './types'

export const STANDARIZED_GOLF_PLAYERS_TABLE_COLUMNS: Column<StandarizedGolfPlayer>[] = [
  {
    id: 'id',
    type: 'text',
    label: 'ID',
    sortAttribute: 'id'
  },
  {
    id: 'displayName',
    type: 'text',
    label: 'Display Name',
    sortAttribute: 'displayName'
  },
  {
    id: 'firstName',
    type: 'text',
    label: 'First name',
    sortAttribute: 'firstName'
  },
  {
    id: 'lastName',
    type: 'text',
    label: 'Last name',
    sortAttribute: 'lastName'
  },
  {
    id: 'etId',
    type: 'text',
    label: 'ET ID',
    sortAttribute: 'europeanTourId'
  },
  {
    id: 'pgaId',
    type: 'text',
    label: 'PGA ID',
    sortAttribute: 'pgaId'
  },
  {
    id: 'lpgaId',
    type: 'text',
    label: 'LPGA ID',
    sortAttribute: 'lpgaTourId'
  },
  {
    id: 'livId',
    type: 'text',
    label: 'LIV ID',
    sortAttribute: 'livId'
  },
  {
    id: 'dateOfBirth',
    type: 'text',
    label: 'DOB',
    sortAttribute: 'dateOfBirth'
  },
  {
    id: 'gender',
    type: 'text',
    label: 'Gender',
    sortAttribute: 'gender'
  }
]

export const STANDARIZED_GOLF_PLAYERS_TABLE_FILTERS: Filter<StandarizedGolfPlayer>[] = [
  {
    type: 'freeTextSearch',
    paramName: 'firstName',
    placeholder: 'Search by first name',
    filterOptions: (row, search) => {
      return row.firstName.toLowerCase().includes(search.toLowerCase())
    },
    width: 200
  },
  {
    type: 'freeTextSearch',
    paramName: 'lastName',
    placeholder: 'Search by last name',
    filterOptions: (row, search) => {
      return row.lastName.toLowerCase().includes(search.toLowerCase())
    },
    width: 200
  }
]
